<template>
    <div class="field" v-bind:class="typeof classes.wrapper != 'undefined' ? classes.wrapper : {}">
        <slot />

		<div class="field__inner">
			<slot name="input" />
		</div>

        <div class="field__error" v-if="error != ''" v-html="error"></div>

		<slot name="extra" />
    </div>
</template>

<script>
    export default {
        name: 'app-field',
        props: {
            error: {
				type: String,
                default: ''
            },
			classes: {
				type: Object,
				default: () => ({})
			},
			append: {
				type: String,
				default: ''
			}
        },
    }
</script>

<style lang="scss">
    .field {
        @apply .relative .block .mb-6;

		&.reset {
			@apply .mb-0;
        }

        &__error {
            @apply .block .mt-2 .mb-4 .text-left .text-red .text-sm;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/fields/Field.vue